import buildRoute from './buildRoute'

export const addBoat = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boat',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getBoats = async (active) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boats',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetBoatProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}
export const getBoatsWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
    manufacturerName,
}: GetBoatProps & { manufacturerName?: string }) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'boatsWithLimiter',
            data: { active, page, limit, filter, manufacturerName },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}
interface GetUserBoatProps {
    active: boolean
    page?: number
    limit?: number
    search?: any
}
export const getUserAssignedBoats = async ({
    active,
    search = '',
    page = 1,
    limit = 20,
}: GetUserBoatProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'user-assigned-get-boats',
            data: { active, page, limit, search },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

export const getProvisionalBoats = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boats-provisional',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const getUnpairedDeviceBoats = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'unpaired-boats',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const editBoat = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boat',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
interface SelectionType {
    data: []
    activate: boolean
}

export const deactivateBoats = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boat-activations',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    data: []
    activate: boolean
}

export const deleteBoat = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boat-deletion',
            data: selection,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

const boatRoutes = {
    getBoats,
    addBoat,
    editBoat,
    deactivateBoats,
    deleteBoat,
    getProvisionalBoats,
    getUnpairedDeviceBoats,
    getBoatsWithLimiter,
    getUserAssignedBoats,
}

export default boatRoutes
